import CustomSelect from "./CustomSelect.js";
import InputMask from "./InputMask.js";

/**
 * PageInteraction module
 *
 * @package AGDS
 * @category Modules
 * @module PageInteraction
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class FormVendors {
    /**
     * Constructor
     *
     * @param {Object} options
     */
    constructor(options = {}) {}

    /**
     * Initialize
     */
    init() {
		// Initialize custom selects
        CustomSelect.selectsInit();

		// Initialize input masks
        InputMask.masksInit();
    }
}
